import {ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'asax-downloading-preparing-data-modal',
  templateUrl: './download-preparing-data-modal.component.html',
  styles: [`
    .download-modal .modal-dialog {
      max-width: 95vw;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class DownloadPreparingDataModalComponent implements OnInit {

  constructor(public modal: NgbActiveModal) {
  }

  ngOnInit(): void {
  }

}
